import { motion } from "framer-motion";
import { SearchX, Clock, TrendingUp, Cog, CheckCircle } from "lucide-react";

const items = [
  { icon: SearchX, text: "Where your leads are dropping off" },
  { icon: Clock, text: "How fast you're responding to inquiries" },
  { icon: TrendingUp, text: "Opportunities to increase booking rates" },
  { icon: Cog, text: "Simple automation improvements" },
  { icon: CheckCircle, text: "Actionable steps to improve performance" },
];

export const WhatYoullGet = () => {
  return (
    <div>
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="text-2xl md:text-3xl font-bold mb-6 text-foreground"
      >
        What We'll Cover
      </motion.h2>
      <div className="space-y-4">
        {items.map((item, i) => (
          <motion.div
            key={item.text}
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.08 }}
            className="flex items-center gap-3"
          >
            <div className="p-2 rounded-lg bg-primary/10 shrink-0">
              <item.icon className="h-4 w-4 text-primary" />
            </div>
            <span className="text-foreground">{item.text}</span>
          </motion.div>
        ))}
      </div>
    </div>
  );
};
